import { useAuth } from "../../../../store/AuthContext/AuthContext";

export const ROLES: any = {

    ROLE_ADMIN: "Administrador",		
    ROLE_CLIENT: "Gran Cuenta",		
    ROLE_AGENT: "Agencias y consultores",
    //ROLE_FREE: "Free",		
    ROLE_MODULE_INFO: "Módulo Info",		
    ROLE_MODULE_REVIEWS: "Módulo Reseñas",		
    ROLE_MODULE_CONTENT: "Módulo Publicaciones",		
    ROLE_MODULE_USERS: "Role Usuarios",		
    ROLE_NETWORK: "Red de Ubicaciones",
    ROLE_COMPETITORS: "Competidores",
    ROLE_QR_SCANS: "QR Analytics",
    ROLE_WEB_WIDGETS: "Web Widgets",
    ROLE_SENTIMENT_ANALYSIS: "Análisis de sentimiento",
    ROLE_API: "Acceso a API",    
    ROLE_SCHEDULED_POSTS: "Agendar Posts",
    ROLE_AUTOMATED_REVIEWS: "Automatizar Reseñas",
    ROLE_GUEST_VIEW: "Invitado",
    ROLE_GUEST_INFO_EDIT: "Editar Ficha",
    ROLE_GUEST_REVIEWS_EDIT: 'Contestar Reseñas',
    ROLE_GUEST_CONTENT_EDIT: 'Publicar Contenido',
    ROLE_APP_BASE: 'Unilocal Base',
    ROLE_APP_AI: 'Unilocal IA',
    ROLE_APP_WEB: 'Unilocal Web'
};

export const MODULES: any = {
    
    COMPETITORS: ["ROLE_ADMIN", "ROLE_COMPETITORS"],
    SENTIMENT_ANALYSIS: ["ROLE_ADMIN", "ROLE_SENTIMENT_ANALYSIS"],    
    WEB_SYNC: ["ROLE_ADMIN", "ROLE_WEB_WIDGETS"],
    QR_ANALYTICS: ["ROLE_ADMIN", "ROLE_QR_SCANS"],
    USERS: ["ROLE_ADMIN", "ROLE_MODULE_USERS"],
    API: ["ROLE_ADMIN", "ROLE_API"],
    MAIL: ["ROLE_ADMIN", "ROLE_API"], // TODO Review if Deprecated ???
    AUTOMATED_REVIEWS: ["ROLE_ADMIN", "ROLE_AUTOMATED_REVIEWS"],
    SCHEDULED_POSTS: ["ROLE_ADMIN", "ROLE_SCHEDULED_POSTS"],
    NETWORK: ["ROLE_ADMIN", "ROLE_NETWORK"],
    TEST_MODULE: []
}

export const useIsAuthorized = () : (roles: string[]) => boolean => {
    
    const { profile } = useAuth();

    return (roles: string[]) => {
        
        let isAuthorized = false;
        roles.forEach(role => {
            
            if (profile.roles && profile.roles.includes(role)) { 
                isAuthorized = true;
            }
        })
        return isAuthorized;
    }
}

export const useModuleActive = () : (module: string) => boolean => {
    
    const { profile } = useAuth();

    return (module: string) => {
     
        let isActive = false;

        MODULES[module].forEach((role: any) => {
            
            if (profile.roles && profile.roles.includes(role)) { 
                isActive = true;
            }
        })        
        return isActive;
    }
}

export const useBasePlan = (): () => string => {
    
    const { profile } = useAuth();
    
    const BASE_PLAN = ["ROLE_ADMIN", "ROLE_CLIENT", "ROLE_AGENT", "ROLE_MODULE_INFO", "ROLE_MODULE_REVIEWS", "ROLE_MODULE_CONTENT"];
    
    return () => {
        const foundRole = profile.roles 
            ? BASE_PLAN.find(baseRole => profile.roles.includes(baseRole))
            : undefined;
                  
        return foundRole || "";
    };
};